<template>
  <v-dialog v-model="searchModal" max-width="1200px" scrollable persistent>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <mf-search :value="textFieldValue" :placeholder="textFieldLabel" />
      </div>
    </template>
    <v-card class="modal-card">
      <v-card-title>
        <span class="pa-1 title">{{ titleName }}</span>
        <v-spacer />
        <a v-if="!noUploadCsv" class="caption" @click="uploadCsv">subir arquivo .csv</a>
        <file-input v-show="false" ref="inputFile" :file-contents.sync="fileContent" @content-updated="updatedFileInput" />
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <mf-search autofocus :value="searchValue" class="mb-2 mx-3" :loading="loading" @input="querySelections" />
          </v-flex>
          <v-flex class="pb-3" xs7>
            <span class="pl-3 body-1">{{ capitalize(configs.categoria_produto.itemString) }}s</span>
            <span class="body-1">({{ searchedItems.length }})</span>
          </v-flex>
          <v-flex class="pb-3" xs5>
            <span class="pl-3 body-1">Selecionados</span>
            <span class="body-1">({{ chosenItems.length }})</span>
          </v-flex>

          <v-flex xs7 class="light-background">
            <div class="modal-div">
              <v-list class="pt-0 light-background">
                <v-list-item
                  v-for="(item, searchedIndex) in searchedItems"
                  :key="`${item[configs.categoria_produto.idPropertyName]}-${searchedIndex}`"
                  class="searched-list"
                  @click="setItem(item[configs.categoria_produto.idPropertyName], searchedItems, chosenItems)"
                >
                  <v-list-item-content v-if="!productsCategory">
                    <span class="body-1">{{ item[configs.categoria_produto.idPropertyName] }} - {{ item[configs.categoria_produto.propertyName] }}</span>
                  </v-list-item-content>
                  <v-list-item-content v-else>
                    <span class="body-1">{{ item[configs.categoria_produto.propertyName] }}</span>
                  </v-list-item-content>
                  <v-list-item-action>
                    <mf-icon>chevron_right</mf-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
          </v-flex>
          <v-flex class="dark-background" xs5>
            <div v-if="chosenItems.length" class="modal-div">
              <v-list-item @click="clearAll">
                <v-list-item-content>
                  <span class="caption">Limpar todos</span>
                </v-list-item-content>
              </v-list-item>
              <div v-for="(item, chosenIndex) in chosenItems" :key="`${item[configs.categoria_produto.idPropertyName]}-${chosenIndex}`" class="px-3">
                <v-chip
                  v-if="!productsCategory"
                  class="body-2 mb-3"
                  close
                  @click:close="setItem(item[configs.categoria_produto.idPropertyName], chosenItems, searchedItems)"
                >
                  {{ item[configs.categoria_produto.idPropertyName] }} -
                  {{
                    item[configs.categoria_produto.propertyName].length > 35
                      ? item[configs.categoria_produto.propertyName].substring(0, 35) + '...'
                      : item[configs.categoria_produto.propertyName]
                  }}
                </v-chip>
                <v-chip v-else class="body-2 mb-3" close @click:close="setItem(item[configs.categoria_produto.idPropertyName], chosenItems, searchedItems)">
                  {{
                    item[configs.categoria_produto.propertyName].length > 35
                      ? item[configs.categoria_produto.propertyName].substring(0, 35) + '...'
                      : item[configs.categoria_produto.propertyName]
                  }}
                </v-chip>
              </div>
            </div>
            <div v-else>
              <v-alert class="ma-3" type="info" outlined> Selecione um {{ configs.categoria_produto.itemString }} </v-alert>
            </div>
          </v-flex>
        </v-layout>
        <mf-action-buttons
          :primary-button="{
            text: 'Confirmar',
            action: confirmChanges,
            isVisible: true,
            isDisabled: disableSave,
            tooltip: tooltipPrimaryButton,
            tooltipMessage: tooltipPrimaryButtonMessage,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: () => (searchModal = false),
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { sortBy, capitalize, cloneDeep, find, findIndex } from 'lodash'
import { assertArray } from '@/config/helpers.js'
import { mapWaitingActions } from 'vue-wait'
import { QUERY_GET_FINAL_CONSUMER_CATEGORIES } from './graphql'

import FileInput from '@/components/FileInput.vue'

export default {
  components: {
    FileInput,
  },
  props: {
    buttonText: {
      type: String,
      default: '',
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    itemType: {
      type: String,
      default: '',
    },
    isSegmentation: {
      type: Boolean,
      default: false,
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
    tooltipPrimaryButton: {
      type: Boolean,
      default: false,
    },
    tooltipPrimaryButtonMessage: {
      type: String,
      default: '',
    },
    productsCategory: {
      type: Boolean,
      default: false,
    },
    titleName: {
      type: String,
      default: 'Buscar categorias de produtos',
    },
    noUploadCsv: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    sortBy,
    capitalize,
    loading: false,
    timeout: null,
    chosenItems: [],
    searchedItems: [],
    searchModal: false,
    textFieldValue: null,
    searchValue: null,
    fileContent: null,
    configs: {
      categoria_produto: {
        actionName: 'searchCategories',
        itemString: 'categoria produto',
        propertyName: 'name',
        idPropertyName: 'id',
      },
    },
    fileTypes: [
      'text/comma-separated-values',
      'text/csv',
      'application/csv',
      'application/excel',
      'application/vnd.ms-excel',
      'application/vnd.msexcel',
      'text/anytext',
      '',
    ],
  }),
  computed: {
    textFieldLabel() {
      return `${capitalize(this.configs.categoria_produto.itemString)}s`
    },
    selectedOption: {
      get() {
        return this.selectedItems
      },
      set(value) {
        this.$emit('update:selectedItems', value)
      },
    },
  },
  watch: {
    searchModal(value) {
      if (value) {
        this.searchedItems = []
        this.searchValue = null
        if (this.isSegmentation && this.selectedItems.length) this.getFoundSelectedItems()
        else this.chosenItems = cloneDeep(this.selectedItems)
      }
    },
    selectedItems() {
      this.updateTextFieldValue()
    },
  },
  methods: {
    ...mapWaitingActions({
      searchCategoriesList: 'search-categories-list',
      searchCategories: 'search-categories',
    }),
    querySelections(query) {
      this.searchValue = query
      if (!query || query.length < 3) return
      this.loading = true
      const self = this
      window.clearTimeout(this.timeout)
      this.timeout = window.setTimeout(() => {
        self.searchItem(query)
      }, 500)
    },
    clearAll() {
      this.loading = true
      this.chosenItems = []
      if (this.searchValue) this.searchItem(this.searchValue)
      else this.loading = false
    },
    setItem(itemId, removeList, pushList) {
      const itemObject = find(removeList, {
        [this.configs.categoria_produto.idPropertyName]: itemId,
      })
      if (!itemObject) return
      const itemObjectIndex = findIndex(removeList, itemObject)
      removeList.splice(itemObjectIndex, 1)
      pushList.unshift(itemObject)
    },
    confirmChanges() {
      this.selectedOption = this.chosenItems
      this.$emit('input')
      this.searchModal = false
      this.$emit('confirm')
    },
    removeChosenItems(responseData) {
      const array = responseData
      for (let item of this.chosenItems) {
        let itemIndex = findIndex(array, item)
        if (itemIndex > -1) {
          array.splice(itemIndex, 1)
        }
      }
      return array
    },
    async searchItem(query) {
      if (this.productsCategory) {
        try {
          const {
            data: { categoriesFinalConsumer },
          } = await this.$apollo.query({
            query: QUERY_GET_FINAL_CONSUMER_CATEGORIES,
            variables: {
              search: query,
            },
          })
          const departments = categoriesFinalConsumer.departments.map((department) => {
            return { id: department._id, name: department.name, type: 'department' }
          })
          const categories = categoriesFinalConsumer.categories.map((categories) => {
            return { id: categories._id, name: categories.name, type: 'categories' }
          })
          const sub_categories = categoriesFinalConsumer.sub_categories.map((subCategories) => {
            return { id: subCategories._id, name: subCategories.name, type: 'sub_categories' }
          })
          const flattenCategories = [...departments, ...categories, ...sub_categories]
          this.searchedItems = this.removeChosenItems(assertArray(flattenCategories))
        } catch (error) {
          this.$snackbar({ message: 'Erro ao buscar categorias.', snackbarColor: 'error' })
        } finally {
          this.loading = false
        }
      } else {
        this.$store
          .dispatch(this.configs.categoria_produto.actionName, {
            categoria_produto: query,
          })
          .then((response) => {
            this.searchedItems = this.removeChosenItems(assertArray(response.data || response.found))
            this.loading = false
          })
      }
    },
    updateTextFieldValue() {
      if (this.selectedItems.length === 1) this.textFieldValue = this.selectedItems.length + ' selecionada'
      else this.textFieldValue = this.selectedItems.length + ' selecionadas'
    },
    updatedFileInput() {
      const fileType = this.$refs.inputFile.fileType
      if (!this.fileContent) return
      if (!this.fileTypes.includes(fileType)) {
        this.$snackbar({ message: `Permitido apenas arquivos em .csv, o arquivo tem o formato: ${fileType}`, snackbarColor: 'error' })
        return
      }
      const idList = this.fileContent
        .split('\n')
        .map((object) => object.split(';')[0].trim())
        .filter((element) => /^\d+$/.test(element.trim()))
      if (!idList.length) {
        this.$snackbar({ message: `Não foi possível importar os dados do arquivo`, snackbarColor: 'error' })
        return
      }
      this.searchCategoriesList(idList).then((response) => {
        response['found'].forEach((product) => {
          const equalItem = product
          if (!equalItem.length) this.chosenItems.push(product)
        })
      })
    },
    uploadCsv() {
      this.$refs.inputFile.activateInput()
    },

    getFoundSelectedItems() {
      this.getSelectedCategories()
    },

    getSelectedCategories() {
      const idsSelecteds = {
        id: this.selectedItems,
      }
      this.searchCategoriesList(idsSelecteds).then((response) => {
        response.found.forEach((categorie) => {
          let equalItem = this.chosenItems.filter((obj) => obj.id === categorie.id)
          if (!equalItem.length) this.chosenItems.push(categorie)
        })
      })
    },
  },
}
</script>

<style lang="scss">
.modal-card {
  .modal-div {
    height: 350px;
    overflow-y: auto;
  }
  .light-background {
    background-color: $cinza-l90;
  }
  .dark-background {
    background-color: $cinza-l90;
  }
  .searched-list {
    border-top: 1px solid $cinza-l70;
  }
  .caption {
    text-decoration: underline;
  }
}
</style>
